<template>
    <div>
        <!-- 标题-->
        <el-card class="box-card" shadow="never" style="border:0;">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <div slot="header" style="border-bottom:0;">
                <span style="font-size:20px;">设备管理</span>
            </div>
        <!--创建活动 按钮-->
        <!--@click="getData" icon="search":loading="loading"-->
        <!--<el-button type="primary" @click="toCreate()">
            创建设备
        </el-button>-->
        <!--搜索活动-->

        <div style="margin-top: 10px">
            <el-select class="m-1" v-model="branchId" placeholder="分部" @change="getData()">
                <el-option v-for="(item,index) in branchList" :label="item.branchName" :value="item.branchId">{{item.branchName}}</el-option>
            </el-select>
            <!--<el-select class="m-1" clearable v-model="orgId" placeholder="机构" @change="getData()">
                <el-option v-for="(item,index) in orgList" :label="item.org_name" :value="item.org_id">{{item.org_name}}</el-option>
            </el-select>-->
            <el-input v-model="deviceId" clearable placeholder="设备编号" style="width: auto;"></el-input>
            <el-input v-model="deviceName" clearable placeholder="设备名称" style="width: auto;"></el-input>
            <el-button type="primary" class="" @click="secrehData()">
                查询
            </el-button>
        </div>
        <!-- 表格分页-->
        <div class="block">
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column prop="deviceId" label="设备编号"></el-table-column>
                <el-table-column prop="deviceName" label="设备名称"></el-table-column>
                <el-table-column prop="branchName" label="分部名称"></el-table-column>
                <el-table-column prop="address" label="设备地址"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" :formatter="formatter" sortable>
                </el-table-column>
                <el-table-column prop="status" label="在线状态" :formatter="statusFormatter">
                </el-table-column>
                <!--<el-table-column label="操作">
                    <template scope="scope">
                        <el-button size="small" type="text" @click="goToEditer(scope.row)">
                            编辑
                        </el-button>
                        <el-button size="small" type="text" @click="deleteDevice(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>-->
            </el-table>
        </div>
        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    background
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
        </el-card>
    </div>
</template>

<script>
    // import action from "../../../store/actions"
    import moment from 'moment'

    export default {
        name: "ActivityManager",
        data() {
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                name: '',
                orgList:[],
                branchList:[],
                loading: false,
                isable: false,
                dialogVisible: false,
                tenantId:'',//租户ID
                kioskNo:'',
                orgId:'',
                branchId:'',
                deviceId:'',
                deviceName:'',
                token:'123123123'
            }
        },
        created() {
            this.tenantId = this.getcookie("storeId");
//            this.getOrgList();
            this.getBranchList();
        },
        methods: {
            getOrgList(){
                this.$http.get(this.deviceHost+"/vueFeign/findOrgList?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.orgList = response.body.Data;
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            getBranchList(){
                this.$http.get(this.deviceHost+"/vueFeign/findBranchs?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.branchList = response.body.Data.branchs;
                            this.branchId = response.body.Data.branchs[0].branchId;
                            this.getData();
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            secrehData(){
                this.currentpage=1;
                this.activeNum=0;
                this.getData();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagesize = val
                this.activeNum = (val * this.currentpage) - val;
                this.endNum = (val * this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val) {
                this.currentpage = val;
                this.activeNum = (this.pagesize * val) - this.pagesize
                this.endNum = (this.pagesize * val)
                this.getData();
            },
            getData() {
                //数据请求
                this.loading = true
                //异步请求
                var orgId='';
                if(this.orgId!=null){
                    orgId = this.orgId;
                }else{
                    orgId = '';
                }
                this.$http.get(this.deviceHost+this.findDeviceListURL + "?active="
                    + this.activeNum + "&len=" + this.pagesize+"&deviceId="+this.deviceId+"&deviceName="
                +this.deviceName+"&orgId="+orgId+"&branchId="+this.branchId+"&tenantId="+this.tenantId+"&Token="+this.token)
                    .then(response => {
                        console.log(response.body)
                        if (response.status === 200) {
                            this.pagesCount = response.body.Data.count;
                            this.tableData = response.body.Data.Devices;
                            this.loading = false;
                            console.log( this.pagesCount);
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            /*编辑页面跳转*/
            toCreate(row){
                this.savecookie("button", "addDevice");
                this.$router.push({
                    path: "addDevice"
                });
            },
            goToEditer(row){
                this.savecookie("button", "modifyDevice");
                console.log("编辑按钮："+row.id)
                this.$router.push({
                    path: "modifyDevice",query:{id:row.id,}
                });
            },
            /*删除活动*/
            deleteDevice(row){
                this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //数据请求
                    this.loading = true
                    var params = {tenantId:this.tenantId,id:row.id,Token:this.token};
                    //异步请求
                    this.$http.post(this.deviceHost+this.delDeviceUrl,params)
                        .then(response => {
                            if (response.status === 200) {
                                if (response.body.Code == "200") {
                                    this.$message({showClose: true, message: '删除成功', type: 'success'});
                                    this.getData();
                                }else if (response.body.Code != "500"&&response.body.Code != "200") {
                                    this.$message({
                                        showClose: true,
                                        message: response.body.Meta,
                                        type: 'error'
                                    });
                                }else if (response.body.Code == "500") {
                                    this.$message({
                                        showClose: true,
                                        message: '系统异常',
                                        type: 'error'
                                    });
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'
                            });
                        })
                })
            },
            /*日期转换时间戳*/
            timeCycle(time) {
                var date = new Date(time.replace(/-/g, '/'));
                return date.getTime();
            },
            statusFormatter(row, column){
                var status = row.status=='online'?'在线':'离线';

                return status;
            },
            formatter(row, column) {
                var d = new Date(row.createTime);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// deviceManager.vue?e0255cb4